/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowALeftIcon20Solid = forwardRef('ArrowALeftIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M9.165 15.679a1.25 1.25 0 1 1-1.767 1.767L2.16 12.21a3.125 3.125 0 0 1 0-4.42l5.237-5.236A1.25 1.25 0 1 1 9.165 4.32L4.737 8.75H17.5a1.25 1.25 0 1 1 0 2.5H4.737l4.428 4.429Z" })));
});
